import type { GenderEnum } from '@gql/graphql';
import type { Dayjs } from 'dayjs';
import type { SelectOption } from '..';
import type { ModalData } from '../Modal';

export interface MtApplicationsOwnModalFormValues {
  name?: string;
  breed?: number;
  birthday?: Dayjs;
  gender?: GenderEnum;
  action?: MtApplicationsOwnModalActionType;
}
export type MtApplicationsOwnModalActionType = 'own' | 'waitlist';
export interface MtApplicationsOwnModalData {
  modal: ModalData;
  formOptions: {
    showNameField: boolean;
    breedIds: SelectOption<number>[];
    showActionsField: boolean;
    actions: SelectOption<MtApplicationsOwnModalActionType>[];
  };
  isLoading: boolean;
}

export interface MtApplicationsOwnModalProps extends MtApplicationsOwnModalData {}
